import { useSelector } from 'react-redux';



const GetInTouch = ({ heading, message, email }) => {

  const setLanguage = useSelector((state) => state.estado.value)
    if (setLanguage === false) {
      heading = "Entre em contato"
      message = ""
    }

  return (
    <>
      <h2 className="display-4 pb-3 text-center">{heading}</h2>
      <p className="lead text-center pb-3">
        {message} <a className="text-decoration-none" href={`mailto:${email}`}>{email}</a>.
      </p>
    </>
  );
};

export default GetInTouch;
